import React, { useEffect, useState } from 'react';
import {
  Elements,
  StripeProvider
} from "react-stripe-elements";

import StripeScriptLoader from '../../common/components/StripeScriptLoader/StripeScriptLoader';
import { getStripePublishableKey } from "../../common/utils/config";
import Button from "../../common/components/Button";
import CreditCardForm from "./components/CreditCard/Form";
import CreditCardView from "./components/CreditCard/View";
import Info from "./components/UI/Info";


export default function CardDetails({ brand, exp_month, exp_year, last4 }) {
  const [editing, setEditing] = useState(false);
  const [info, setInfo] = useState(false);
  const [credit_card, setCreditCard] = useState({
    brand: brand,
    exp_month: exp_month,
    exp_year: exp_year,
    last4: last4
  });

  const handleSave = (card_details) => {
    setCreditCard(card_details);
    setEditing(!editing);
    setInfo('Change completed')
  };

  const handleCancel = () => {
    setEditing(!editing);
  };

  return (
    <div className="credit-card-form">
      {!editing &&
        <div className="row">
          <div className="col-md-3 vcenter">
            <CreditCardView {...credit_card}/>
          </div>
          <div className="col-md-2 vcenter">
            <Button
              type="submit"
              className="-block"
              onClick={() => { setEditing(!editing); setInfo(''); } }
            >
              Change
            </Button>
          </div>
        </div>
      }
      {editing &&
        <div className="row">
          <div className="col-md-6 vcenter">
            <StripeScriptLoader
              uniqueId='stripe-js'
              script='https://js.stripe.com/v3/'
              loader="Connecting to Stripe..."
            >
              <StripeProvider apiKey={getStripePublishableKey()}>
                <Elements>
                  <CreditCardForm onSave={handleSave} onCancel={handleCancel} />
                </Elements>
              </StripeProvider>
            </StripeScriptLoader>
          </div>
        </div>
      }
      {info &&
      <Info info={info} />
      }
    </div>

  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/card_details/index.js